import { useEffect, useState } from 'react';
import { getCustomerType } from '../api/customerTypeApi';
import { CustomerType } from '../types/customerType';

/**
 * The instance's customer type, or null while loading / when unset.
 *
 * Gate fields with a direct comparison, treating null as "show everything":
 *   customerType === null || customerType === 'stiftelse'
 *   customerType !== 'bostadsrattsforening'
 */
export function useCustomerType(): CustomerType | null {
    const [customerType, setCustomerTypeState] = useState<CustomerType | null>(null);

    useEffect(() => {
        let cancelled = false;
        getCustomerType().then(type => {
            if (!cancelled) setCustomerTypeState(type);
        });
        return () => { cancelled = true; };
    }, []);

    return customerType;
}
